/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";

import { EnvelopeIcon, FaStarIcon, NotificationIcon } from "../icons";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Dropdown } from "primereact/dropdown";



export default function TopBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const stats = useSelector((state) => state.user.stats);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [selectedCity, setSelectedCity] = useState(null);
  const [cities, setCity] = useState([
    { name: 'Auction', code: 'AKM', path: '/', icon: <img src="metro-hammer.png" style={{ width: 13 }} alt="Live Auction" /> },
    { name: 'Tender', code: 'RM', path: "/tender", icon: <img src="metro-hammer.png" alt="Live Auction" style={{ width: 13 }} /> },
    { name: 'Negotiation Auction', code: 'NY', path: "/negotiation", icon: <img src="metro-hammer.png" alt="Live Auction" style={{ width: 13 }} /> },
  ])
  const [buttons, setButtons] = useState([
    {
      path: "/favourites",
      text: "Favorite List",
      icon: {
        active: <FaStarIcon />,
        inactive: <FaStarIcon />,
      },
      countKey: 'favoriteCount'
    },
    {
      path: "/tender",
      text: "Tender Auction",
      icon: {
        active: <img src="hammer.png" alt="Tender Auction" />,
        inactive: <img src="metro-hammer.png" alt="Tender Auction" />,
      },
      countKey: 'tenderAuctionCount'
    },
    {
      path: "/negotiation",
      text: "Negotiation Auction",
      icon: {
        active: <img src="hammer.png" alt="Negotiation Auction" />,
        inactive: <img src="metro-hammer.png" alt="Negotiation Auction" />,
      },
      countKey: 'negotiationAuctionCount'
    },
    {
      path: "/",
      text: "Inquiries",
      icon: {
        active: <img src="question.png" alt="Inquiries" style={{ objectFit: "contain" }} />,
        inactive: <img src="question.png" alt="Inquiries" style={{ objectFit: "contain" }} />
      },
      countKey: 'inquiresCount'
    },
    {
      path: "/notification",
      text: "Notification",
      icon: {
        active: <EnvelopeIcon />,
        inactive: <EnvelopeIcon />,
      },
      countKey: 'notificationCount'
    },
  ])

  useEffect(() => {

    if (stats && stats.liveAuctionCount > 0 && buttons.length === 5) {
      const buttonsToIterate = buttons;
      buttonsToIterate.splice(1, 0, {
        path: "/live-auction",
        text: "Live Auction",
        icon: {
          active: <img src="hammer.png" alt="Live Auction" />,
          inactive: <img src="metro-hammer.png" alt="Live Auction" />,
        },
        countKey: 'liveAuctionCount'
      },);

      setButtons(buttonsToIterate);
      setCity([...cities, { name: 'Live Auction', code: 'LDN', path: "/live-auction", icon: <img src="metro-hammer.png" alt="Live Auction" style={{ width: 13 }} /> }])
    }
  }, [stats]);

  const isActive = (path) => location.pathname === path;

  const handleCitySelect = (selectedCity) => {
    setSelectedCity(selectedCity);
    if (selectedCity.path) {
      navigate(selectedCity.path);
    }
  };
  const selectedCityTemplate = (option, props) => {
    return (
      <div className="prime-select" style={option && option.name === 'Auction' ? { textAlign: "center" } : { textAlign: "center", color: 'white' }}>
        <div>{option && option.name !== 'Auction' ? <img src="hammer.png" style={{ width: 13 }} alt="Live Auction" /> : option?.icon}</div>
        <div>{option?.name}</div>
      </div>
    );
  };
  const cityOptionTemplate = (option) => {

    return (
      <div className="prime-select" style={{ textAlign: "center" }}>
        <div>{option.icon}</div>
        <div>{option.name}</div>
      </div>
    );
  };

  useEffect(() => {
    const foundObj = cities.find(x => x.path === location.pathname)

    if (foundObj) {
      setSelectedCity(foundObj)
    }

    if (!foundObj) {
      setSelectedCity(cities[0])
    }

  }, [location.pathname])

  return (
    <div className="container-fluid top-bar" >
      {!isMobile && buttons.map((button) => (
        <button
          key={button.path}
          className={isActive(button.path) && button.path !== '/' ? "active" : ""}
          onClick={() => navigate(button.path)}
        >
          {typeof button.icon === "object" ? (
            isActive(button.path) ? (
              button.icon.active
            ) : (
              button.icon.inactive
            )
          ) : (
            button.icon
          )}
          {button.text}
          <NotificationIcon count={stats[button.countKey]} />
        </button>
      ))}
      {isMobile && (
        <div className="mobile" style={{ display: 'flex', flexDirection: 'row' }} >
          <button
            className={location.pathname === '/favourites' ? "active" : ""}
            onClick={() => navigate('favourites')}
          >
            <FaStarIcon />
            Favourites
            <NotificationIcon count={stats['favoriteCount']} />
          </button>
          <div>
            <Dropdown style={selectedCity && selectedCity.name !== 'Auction' ? { color: 'black', width: 100, height: 35, display: "flex", border: '2px solid #0964CE', textAlign: "center", background: '#053FA1' } : { color: 'black', width: 100, height: 35, display: "flex", border: '2px solid #0964CE', textAlign: "center" }}
              value={selectedCity}
              onChange={(e) => handleCitySelect(e.value)}
              options={cities}
              optionLabel="name"
              placeholder="Auction"
              valueTemplate={selectedCityTemplate}
              itemTemplate={cityOptionTemplate}
            />
          </div>
          <button
            className={location.pathname === '/notification' ? "active" : ""}
            onClick={() => navigate('notification')}
          >
            <EnvelopeIcon />
            Notification
            <NotificationIcon count={stats['notificationCount']} />
          </button>
        </div>
      )}
    </div>
  );
}

